<template>
    <el-dialog
        title="移交创建"
        width="1000px"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        class="waybill-transfer-create-dialog"
    >
        <el-form
            :model="form"
            :rules="config.rules"
            label-width="100px"
            class="from"
            ref="ruleForm"
        >
            <el-row :gutter="4">
                <el-col :span="8">
                    <el-form-item label="移交单号" prop="transferNo">
                        <el-input
                            disabled
                            v-model.trim="form.transferNo"
                            placeholder="自动生成"
                            maxlength="10"
                            clearable
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="移交类型" prop="transType">
                        <otpSelect
                            :optionNum="'TMS_TANSFER_WAY'"
                            :mValue="form.transType"
                            @getSelectValue="getTransTypeSelectValue"
                            placeholder="请选择移交类型"
                            :prop="'transType'"
                        ></otpSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="移交分公司" prop="companyName">
                        <advance-dialog
                            v-model="form.companyName"
                            :params="config.companyNames"
                            :mValue="form.companyName"
                            @getAdvanceValue="getCompanyNameSelectValue"
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="4">
                <el-col :span="8">
                    <el-form-item label="移交服务平台" prop="siteName">
                        <advance-dialog
                            :disabled="!form.companyName"
                            v-model="form.siteName"
                            :params="config.siteParams"
                            :mValue="form.siteName"
                            :formData="form"
                            @getAdvanceValue="getSelectValue"
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="+form.transType === 1">
                    <el-form-item label="接收分公司" prop="receiptCompanyName">
                        <advance-dialog
                            v-model="form.receiptCompanyName"
                            :params="config.receiptCompanyNames"
                            :mValue="form.receiptCompanyName"
                            @getAdvanceValue="getReceiptCompanyNameSelectValue"
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="+form.transType === 1">
                    <el-form-item label="接收服务平台" prop="receiptSiteName">
                        <advance-dialog
                            :disabled="!form.receiptCompanyName"
                            v-model="form.receiptSiteName"
                            :params="config.receiptSiteNames"
                            :mValue="form.receiptSiteName"
                            :formData="form"
                            @getAdvanceValue="getSelectValue"
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="移交方式" prop="transferType">
                        <otpSelect
                            :optionNum="'TRANSFER_TYPE'"
                            :mValue="form.transferType"
                            @getSelectValue="getTransferTypeSelectValue"
                            placeholder="请选择移交方式"
                            :prop="'transferType'"
                        ></otpSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="接收人" prop="receiptPersonName">
                        <el-input
                            v-model.trim="form.receiptPersonName"
                            placeholder="请输入接收人"
                            maxlength="20"
                            clearable
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="+form.transferType === 2">
                    <el-form-item label="快递单号" prop="courierNumber">
                        <el-input
                            v-model.trim="form.courierNumber"
                            maxlength="30"
                            placeholder="请输入快递单号"
                            clearable
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="移交人" prop="transferPersonName">
                        <el-input
                            disabled
                            v-model.trim="form.transferPersonName"
                            placeholder="请输入移交人"
                            maxlength="10"
                            clearable
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSure" :loading="loading"
                >确 认</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import advanceDialog from '@/components/lots/otpAdvance';
import otpSelect from '@/components/lots/otpSelect';
import config from './config';
import { generateTransfer } from '@/modules/transport/otp/api/performanceTransferCenter';
export default {
    name: 'WaybillTransferCreate',
    components: { advanceDialog, otpSelect },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        transferCreatResponseList: {// 需要移交确认输集合
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            config,
            // dialogVisible: false,
            form: {
                transferNo: '', // 移交单
                transType: '', // 移交类型: 平台移交： 1， 结算移交： 2
                companyName: '', // 移交分公司
                companyCode: '', // 移交分公司编码
                siteCode: '', // 移交服务平台编码
                siteName: '', // 移交服务平台名称
                receiptCompanyName: '', // 接收分公司名称
                receiptCompanyCode: '', // 接收分公司编码
                receiptSiteName: '', // 接收服务平台名称
                receiptSiteCode: '', // 接收服务平台编码
                transferType: '', // 移交方式： 跟车： 0， 现场： 1， 快递： 2
                receiptPersonName: '', // 接收人
                receiptPersonCode: '', // 接收人编码
                courierNumber: '', // 快递单号
                transferPersonName: '', // 移交人名称
                transferPersonCode: '' // 移交人编码

            },
            loading: false
        };
    },
    mounted () {
        this.form.transferPersonCode = this.user.userCode;
        this.form.transferPersonName = this.user.userName;
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        getSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
        },
        // 移交类型
        getTransTypeSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
            // 移交方式非现场
            if (+data.transType !== 1) {
                this.form.receiptCompanyName = '';
                this.form.receiptCompanyCode = '';
                this.form.receiptSiteCode = '';
                this.form.receiptSiteName = '';
            }
        },
        // 移交分公司
        getCompanyNameSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
            this.form.siteCode = '';
            this.form.siteName = '';
        },
        // 接收分公司
        getReceiptCompanyNameSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
            this.form.receiptSiteCode = '';
            this.form.receiptSiteName = '';
        },
        // 移交方式
        getTransferTypeSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
            // 移交方式非快递
            if (+data.transferType !== 2) {
                this.form.courierNumber = '';
            }
        },
        handleClose () {
            this.form = {};
            this.$emit('close', false);
        },
        handleSure () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    const params = {
                        ...this.form,
                        customerCode: this.transferCreatResponseList[0].customerCode,
                        customerName: this.transferCreatResponseList[0].customerName,
                        transportList: this.transferCreatResponseList.map(item => item.taskNo)
                    };
                    this.loading = true;
                    generateTransfer(params).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.msg);
                            this.form = {};
                            this.$emit('close', true);
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
